import { useState, useMemo } from 'react';
import { useRouteLoaderData } from 'react-router-dom';
import EventListItem from './EventListItem';
import PaginationControls from './components/PaginationControls';
import { Event } from './API';

const EVENTS_PER_PAGE = 10;

function EventList() {
  const events = useRouteLoaderData("events") as Event[];
  const [currentPage, setCurrentPage] = useState(0);

  const liveEvents = useMemo(
    () =>
      (events ?? [])
        .filter((event) => event?.live)
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()),
    [events]
  );

  const totalPages = Math.ceil(liveEvents.length / EVENTS_PER_PAGE);
  const paginatedEvents = liveEvents.slice(
    currentPage * EVENTS_PER_PAGE,
    currentPage * EVENTS_PER_PAGE + EVENTS_PER_PAGE
  );

  return (
    <>
      <div className='dashboard-header-container'>
        <h1 className="dashboard-header">Your Managed Events</h1>
      </div>

      {liveEvents.length === 0 ? (
        <div className="no-events-message">No events to show</div>
      ) : (
        <>
          {paginatedEvents.map((event) => (
            <EventListItem event={event} key={event.eventId} />
          ))}
          {totalPages > 1 && (
            <PaginationControls
              currentPage={currentPage}
              totalPages={totalPages}
              onPrevious={() => setCurrentPage((p) => Math.max(0, p - 1))}
              onNext={() => setCurrentPage((p) => Math.min(totalPages - 1, p + 1))}
            />
          )}
        </>
      )}
    </>
  );
}

export default EventList;
